export default {
    /**
     * update loading state
     * @param state
     * @param loading
     */
    addLoadingTask(state, {task}) {
        state.loadingTasks.push(task);
        state.isLoading = true;
        //console.log(state.loadingTasks, state.isLoading);
    },
    removeLoadingTask(state, {task}) {
        const taskIndex = state.loadingTasks.indexOf(task);
        //console.log(state.loadingTasks, task, taskIndex);
        if(taskIndex < 0) {return;}
        state.loadingTasks.splice(taskIndex, 1);
        state.isLoading = state.loadingTasks.length > 0;
        //console.log(state.loadingTasks, state.isLoading);
    },
    updateErrors(state, {key, errors}) {
        Vue.set(state.errors, key, errors);
    },
    /**
     * get all product for search
     * @param state
     * @param allProducts
     */
    updateAllProducts(state, {allProducts}) {
        state.allProducts = allProducts;
    },
    /**
     * update holidays in store
     * @param state
     * @param holidays
     */
    updateHolidays(state, holidays) {
        state.holidays = holidays;
    },
};